<template>
<v-app id="inspire" style="background: #f8f9fa">
  <div class="pl-5 pr-5">
    <div class="manage-company-title row pa-3" style="background-color: #F8F9FA;">
    <p class="ml-6">
      จัดการเครือและบริษัท
    </p>
    </div>
    <v-tabs
      v-model="tab"
      class="mt-0"
      color="#2BA197"
      background-color="#F8F9FA"
    >
      <v-tabs-slider color="#2BA197"></v-tabs-slider>
      <v-tab v-for="item in itemsCount" :key="item.id" style="font-weight: 700;font-size: 16px;">
        <span>{{ item.name }}</span>
        <!-- <span>{{ 1 }}</span> -->
        <v-chip
          class="ml-2"
          color="#fff"
          text-color="#2BA197"
          small
        >
          <span>{{ item.total }}</span>
        </v-chip>
      </v-tab>

      <v-tabs-items v-model="tab" class="pa-5" style="border-radius: 16px;">
        <v-tab-item>
          <div class="my-2">
            <div>
              <OverviewGroupCompany/>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="my-2">
            <div>
              <OverviewCompany/>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</v-app>
</template>

<script>
import OverviewCompany from './overviewCompany'
import OverviewGroupCompany from './groupCompany/overviewGroupCompany'
export default {
  components: {
    OverviewCompany, OverviewGroupCompany
  },
  name: 'overview',
  data () {
    return {
      countGroup: '',
      countCompany: '',
      tab: null,
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ],
      itemsCount: [
        {
          id: 1,
          name: 'เครือ(กรุ๊ปบริษัท)',
          count: 20
        },
        {
          id: 2,
          name: 'จัดการบริษัท',
          count: 50
        }
      ],
      itemsBread: [
        {
          text: 'Organization',
          disabled: false,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'จัดการเครือและบริษัท',
          disabled: false,
          href: 'breadcrumbs_link_1'
        }
      ]
    }
  },
  mounted () {
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getCompanyCount()
  },
  watched () {
  },
  methods: {
    async getCompanyCount () {
      const temp = []
      const obj = {
        name: 'managecompany'
      }
      try {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/roleManage/countTab`,
          data: obj,
          headers: {
            authorization: this.tokenUser
          }
        }).then((response) => {
          if (response.data.success) {
            response.data.result.map((el, index) => {
              if (el.name === 'group company') {
                el.name = 'เครือ(กรุ๊ปบริษัท)'
              } else if (el.name === 'company') {
                el.name = 'จัดการบริษัท'
              }
              temp.push({
                no: index + 1,
                total: String(el.count),
                ...el
              })
              this.itemsCount = temp
            })
          } else {
            // console.log(response)
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
.manage-company-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
</style>
